import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

class FeedbackAnalytics extends BaseAnalytics {
    constructor(category = 'feedback') {
        super();

        this.category = category;
    }

    positive(agreementNumber: number | null) {
        this.send('feedback_positive', String(agreementNumber));
    }

    negative(agreementNumber: number | null, message?: string) {
        if (message) {
            const agreementWithMessage = `${agreementNumber}|${message}`;
            this.send('feedback_negative_detail', String(agreementWithMessage));
        } else {
            this.send('feedback_negative', String(agreementNumber));
        }
    }
}

export default FeedbackAnalytics;
